import type { GetAssistantRequest, GetAssistantResponse } from '~/api/aspida/@types';
import { sendRequest } from '~/api/sendRequest';

export const getAssistant = sendRequest<GetAssistantRequest, GetAssistantResponse>({
  url: '/assistant',
  method: 'get',
});
